import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function TestimonialsSection() {
  return <section className="w-full bg-cream" data-id="element-304" data-mp="1rv5yez8y3v55">
      <div className="mx-auto w-full max-w-content px-5 py-14 sm:px-8 sm:py-20" data-id="element-305" data-mp="1ru374q7pnqop">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-teal" data-id="element-306" data-mp="1mvtdwl5jr05q">
          Prova sociale
        </p>
        <h2 className="mt-3 text-center font-display text-[30px] font-black leading-[1.1] tracking-[-0.02em] text-plum-deep sm:text-4xl" data-id="element-307" data-mp="1iswtcowg4tz5">
          Ecco cosa dicono i medici
        </h2>

        <div className="mt-9 grid gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-308" data-mp="18x22x7lzdult">
          {testimonials.map(item => <figure key={item.name} className="flex flex-col rounded-3xl bg-white p-5 ring-1 ring-ink/10 sm:p-7" data-id="element-309" data-mp="13ztlxackjwm5">
              <div className="flex items-center gap-1" data-id="element-310" data-mp="2yct6lhvt3h0a">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-311" data-mp="1t82aqg3pedhl" data-mpi={i} />)}
                <span className="sr-only" data-id="element-312" data-mp="1ya1brjbz0ybd">5 stelle su 5</span>
              </div>

              <QuoteIcon className="mt-4 h-6 w-6 shrink-0 fill-plum-soft text-plum-soft" aria-hidden="true" data-id="element-313" data-mp="1jd0k1fts53cw" />

              <blockquote className="mt-2 text-[15.5px] leading-relaxed text-ink/80 sm:text-base" data-id="element-314" data-mp="2bzlbega99fgg">
                “{item.quote}”
              </blockquote>

              <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-315" data-mp="2gyg7ul15b2j1">
                <img src={item.image} alt={`Ritratto di ${item.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-plum/20" width={96} height={96} loading="lazy" data-id="element-316" data-mp="229jzemv6fnhw" />
                <div className="min-w-0" data-id="element-317" data-mp="2zr0i0l92eixi">
                  <p className="text-[14.5px] font-extrabold leading-tight text-plum-deep" data-id="element-318" data-mp="39lfsd9a1002o">
                    {item.name}
                  </p>
                  <p className="mt-0.5 text-[12.5px] font-medium leading-snug text-ink/55" data-id="element-319" data-mp="34n4kh43ajzn3">
                    {item.role}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-320" data-mp="2qmtrnvif8aza">
          <CTAButton label="Unisciti oggi a oltre 2.000 medici" sub="Accesso immediato • 19 € una sola volta" variant="plum" data-id="element-321" data-mp="2qnlplczhqksq" />
        </div>
      </div>
    </section>;
}